var Isotope = require('../../vendors/isotope/js/isotope.js');
var gallery = require('../../vendors/baguettebox.js/src/baguettebox.js');
var imagesLoaded = require('../../vendors/imagesloaded/imagesloaded.js');

class Lab {

	init(){

		var isotope = new Isotope( this.$wrap, {
			itemSelector: '.lab-item'
			// layoutMode: 'fitColumns'
		});

		imagesLoaded( document.querySelector('.lab-list') ).on( 'progress', function(a, b) {
			b.img.classList.add('item-load');
			isotope.layout();
		});

		gallery.run('.lab-list');

	}

	constructor() {

		this.$wrap = document.querySelector('.lab-list');
		if(this.$wrap){

			this.init();

		}

	}

}

module.exports = new Lab;


/** WEBPACK FOOTER **
 ** ./layouts/lab.js
 **/